import { AppShell, Crumb } from '@agribot/polygon-checks-ui'
import { UserAdminPanel } from '@agribot/user-admin'

/** The people screen in our admin section; the screen itself is @agribot/user-admin's. */
export function People() {
  return (
    <AppShell crumbs={[<Crumb key="a">Admin</Crumb>, <Crumb key="b">People</Crumb>]}>
      <UserAdminPanel />
    </AppShell>
  )
}
